import React, { useContext, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import { Link } from 'react-router-dom';

import { validateTextOnly, validateShortCode } from '../../../utility/Utility';
import { addTypeExamData, loadingTypeExamAction } from '../../../store/actions/TypeExamAction';
import { globalLoadingAction } from '../../../store/actions/GlobalAction';

const CreateTypeExam = (props) => {

	const dispatch = useDispatch();
	let errorsObj = { type: '' };

	const [errors, setErrors] = useState(errorsObj);
	const [typeExma, setTypeExma] = useState('');

	useEffect(() => {

	}, []);

	/* form submit */
	function onSubmit(e) {

		e.preventDefault();

		let error = false;
		const errorObj = { ...errorsObj };

		if (typeExma === '') {
			errorObj.type = 'Type of exam name is Required';
			error = true;
		}else if(!/^[a-zA-Z\s]+$/.test(typeExma)){
			errorObj.type = "Only alphabetic characters is allow";
			error = true;
		  }
		setErrors(errorObj);
		if (error) {
			return;
		}

		dispatch(globalLoadingAction(true));
		dispatch(addTypeExamData(typeExma, props.history));
		setTypeExma('');
	}

	return (
		<>
			<div className="row">

				<div className="col-xl-6 col-xl-12">
					<div className="row">

						<div className="col-xl-12">
							<div className="card pt-5 pb-5">
								<div className="row">
									<div className="col-xl-3"></div>
									<div className="col-xl-6">

										<div className="card-body">
											<div className="basic-form">

												<form onSubmit={onSubmit}>

													<div className="form-group mb-3">
														<label className="mb-2">
															<strong>Type of exam<span className="text-danger">*</span></strong>
														</label>
														<input className="form-control" placeholder="Enter the type of exam name" value={typeExma} onChange={(e) => setTypeExma(e.target.value)} />
														{errors.type && <div className="text-danger fs-12">{errors.type}</div>}
													</div>

													<div className="text-center mt-4">
														<button type="submit" className="btn btn-primary btn-block category-btn" disabled={props.showLoading}>
															Submit
															{props.showLoading ?
																<Spinner
																	as="span"
																	animation="border"
																	size="sm"
																	role="status"
																	aria-hidden="true"
																/>
																: null}
														</button>
													</div>

												</form>
											</div>
										</div>

									</div>
									<div className="col-xl-3"></div>
								</div>
							</div>

						</div>

					</div>
				</div>


			</div>
		</>
	)
}

const mapStateToProps = (state) => {
	return {
		showLoading: state.board.showLoading,
	};
};
export default connect(mapStateToProps)(CreateTypeExam);